export default "__VITE_ASSET__937fa298__"